import { Base } from '@studiometa/js-toolkit';
import MasonryLayout from 'masonry-layout';

/**
 * @typedef {{}} MasonryProps
 */

/**
 * Masonry Masonry.
 * @extends {Base<MasonryProps>}
 */
export default class Masonry extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Masonry',
  };

  /**
   * Mount masonry
   */
  mounted() {
    this.msnry = new MasonryLayout(this.$el, {
      itemSelector: '.thumb',
      fitWidth: true,
      gutter: 16,
    });
  }
}
